import React from 'react'

import { Contract, User, UserMetadata } from '../../../../common/validations'
import { useAPIGetUserMetadataSuspense } from '../../../api/apiHooks/useAPIGetUserMetadata'
import { useCurrentContract } from '../../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetUserProfileSuspense } from '../../../api/apiHooks/useAPIGetUserProfile'
import { useAPIGetContractSuspense } from '../../../api/apiHooks/useAPIGetContract'
import { useCurrentQuestionNotice } from '../../../hooks/useCurrentQuestionNotice/useCurrentQuestionNotice'
import { useAPIGetQuestionNoticeSuspense } from '../../../api/apiHooks/useAPIGetQuestionNotice'
import { FeedbackAndQuestionNoticeDetails } from '../../../../common/validations/feedbackAndQuestionNotice'
import { DefectNoticeDefectClasses } from '../../../../common/validations/defectNotice'

import { useAPIGetDefectClassesSuspense } from 'api/apiHooks/useAPIGetDefectClasses'

interface Data {
  contract: Contract
  user: User
  userMetadata: UserMetadata
  questionNotice: FeedbackAndQuestionNoticeDetails
  questionClasses: DefectNoticeDefectClasses
}

export const QuestionViewDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: questionClasses } = useAPIGetDefectClassesSuspense()
  const { data: user } = useAPIGetUserProfileSuspense()

  const { currentQuestionNoticeUuid } = useCurrentQuestionNotice()
  const { data: questionNotice } = useAPIGetQuestionNoticeSuspense(
    currentContractId,
    currentQuestionNoticeUuid
  )

  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  if (!user.phoneNumber) {
    throw new Error('QUESTION_MISSING_PHONE_NUMBER')
  }

  if (!questionNotice) {
    throw new Error('NOT_FOUND')
  }

  return children({
    contract,
    user,
    userMetadata,
    questionNotice,
    questionClasses,
  })
}
